import { oktaAuth } from '../config/OktaConfig'

const url = process.env.REACT_APP_SHIPMENT_TRACKING_API_URL + '/s3-download'

export async function downloadS3Payload(s3Key: string): Promise<void> {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      authorization: `Bearer ${oktaAuth.getAccessToken() || ''}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ s3Key: s3Key }),
  })

  const jsonResponse = await response.json()

  window.open(jsonResponse.presignedUrl, '_self')
}
